import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import { Autocomplete, TextField, Chip, Box, Typography } from "@mui/material";


import { SET_FILTER, SET_LOADING, SET_OPERATOR, SET_COMPANY_IDS, SET_COMPANIES } from '../../actions/types';
import { gisActions } from '../../actions';

const SearchCompanies = ({ value }) => {
  const dispatch = useDispatch();
  const { filter, loading, operator, companies = null, companyIds = null } = useSelector(state => state.fpzReducer);

  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [companyLoading, setCompanyLoading] = React.useState(false);

  function useDebouncedValue(value, delay = 500) {
    const [debounced, setDebounced] = React.useState(value);

    React.useEffect(() => {
      const t = setTimeout(() => setDebounced(value), delay);
      return () => clearTimeout(t);
    }, [value, delay]);

    return debounced;
  }

  const debouncedInput = useDebouncedValue(inputValue, 500);

  useEffect(() => {
    let active = true;
    const q = debouncedInput.trim();
    if (!q) { setOptions([]); return; }

    (async () => {
      setCompanyLoading(true);
      try {
        const data = await gisActions.getCompanies({ operator: q });
        if (active) setOptions(data.items ?? data ?? []);
      } finally {
        if (active) setCompanyLoading(false);
      }
    })();

    return () => { active = false; };
  }, [debouncedInput]);

  return (
    <Paper
      component="form"
      sx={{ p: '1px 1px', display: 'flex', alignItems: 'center', width: '100%' }}
      onSubmit={(e) => { e.preventDefault(); }}
    >
      <Autocomplete
        multiple
        disableCloseOnSelect
        sx={{
          ml: 1,
          flex: 1
        }}
        options={options}
        value={value}
        onChange={(_, newValue) => {
          dispatch({ type: SET_COMPANIES, payload: newValue });
          console.log('Selected companies:', newValue);
        }}
        inputValue={inputValue}
        onInputChange={(_, newInput, reason) => {
          if (reason === "input") {
            setInputValue(newInput);
          }
        }}
        isOptionEqualToValue={(opt, val) => opt.id === val.id}
        getOptionLabel={(opt) => opt.name ?? ""}
        filterOptions={(x) => x} // disable client filtering; server already filtered
        loading={companyLoading}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Companies"
            placeholder="Search companies"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {companyLoading ? <CircularProgress size={18} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            <Box
              sx={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: "1fr auto",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Typography variant="body2" noWrap>
                {option.name}
              </Typography>

              <Typography
                variant="caption"
                sx={{ fontVariantNumeric: "tabular-nums" }}
              >
                {option.well_count ?? 0}
              </Typography>
            </Box>
          </li>
        )}
      />
      <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
        {loading ? <CircularProgress /> : <SearchIcon />}
      </IconButton>
      {/*<IconButton type="button" sx={{ p: '10px' }} aria-label="search" size="small">
        Show All
        <Checkbox
          checked={true}
          onChange={(e) => console.log() }
          title="View Cartofact Wells"
        />
      </IconButton>*/}
    </Paper>
  );
}


export default SearchCompanies;